<ng-template #content let-node>
  <ng-container [ngSwitch]="node.type">
    <span *ngSwitchCase="0"></span>
    <mat-icon class="icon-size-4 mr-1" *ngSwitchCase="2">layers</mat-icon>
    <mat-icon class="icon-size-4 mr-1" *ngSwitchCase="3" svgIcon="edge_material"></mat-icon>
    <mat-icon class="icon-size-4 mr-1" *ngSwitchCase="254" svgIcon="linear_material"></mat-icon>
    <mat-icon class="icon-size-4 mr-1" *ngSwitchCase="4" svgIcon="furniture_material"></mat-icon>
    <mat-icon class="icon-size-4 mr-1" *ngSwitchDefault>help_outline</mat-icon>
  </ng-container>

  <ng-container *ngIf="multiSelect">
    <mat-checkbox
      class="checklist-leaf-node mr-2"
      [checked]="checklistSelection.isSelected(node.id)"
      (change)="nodeItemSelectionToggle(node)">
    </mat-checkbox>
  </ng-container>

  <span class="text-sm">{{ node.name }}</span>
</ng-template>

<div class="tree-wrapper">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="group-material-tree">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <li class="mat-tree-node" matRipple [ngClass]="{ accent: node === activeNode }" (click)="onFocusNode(node)">
        <button mat-icon-button disabled disableRipple class="node-toggle-btn"></button>

        <ng-template *ngTemplateOutlet="content; context: { $implicit: node }"></ng-template>
      </li>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <li>
        <div class="mat-tree-node" matRipple [ngClass]="{ accent: node === activeNode }" (click)="onFocusNode(node)">
          <button
            mat-icon-button
            disableRipple
            [disabled]="node.id === 0"
            class="node-toggle-btn"
            matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror icon-size-4">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>

          <ng-template *ngTemplateOutlet="content; context: { $implicit: getNodeContext(node) }"></ng-template>
        </div>
        <ul [class.group-material-tree-invisible]="!treeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>
      </li>
    </mat-nested-tree-node>
  </mat-tree>
</div>
